<ng-container *ngIf="stepProcess === 'PROCESS'">
  <div class="container-screen">
    <app-app-navigation-header
      [title]="titleSection"
      [backRoute]="backRoute"
      (onClick)="showVerificationScreen($event)"
    ></app-app-navigation-header>
    <div class="grid" style="max-width: 100%; margin: auto;">
      <div class="col-12 main-container-info">
        <ng-container *ngIf="screenVerificationList; else elseVerificationList">
          <app-progress-verification [data]="data"></app-progress-verification>
          <app-verification-documents-list [data]="data" (onClick)="showScreen($event)"></app-verification-documents-list>
          <div class="grid">
            <div class="col-12 close-session">
              <p (click)="closeSession()">Cerrar sesión</p>
            </div>
          </div>
        </ng-container>
        <ng-template #elseVerificationList>
          <ng-container [ngSwitch]="currentScreenType">
            <app-form-component *ngSwitchCase="'FORM'" [data]="currentScreenData" (onEndProcess)="showVerificationScreen($event)"></app-form-component>
            <app-account-validation-component *ngSwitchCase="'DRUO'" [data]="currentScreenData" (onEndProcess)="showVerificationScreen($event)"></app-account-validation-component>
            <app-document-component *ngSwitchCase="'DOCUMENT'" [data]="currentScreenData" (onEndProcess)="showVerificationScreen($event)"></app-document-component>
            <app-ine-validation *ngSwitchCase="'INCODE'" [data]="currentScreenData" (onEndProcess)="showVerificationScreen($event)" (onUpdateStage)="retryFlow()"></app-ine-validation>
            <app-sign-document *ngSwitchCase="'WEETRUST'" [data]="currentScreenData" (onEndProcess)="showVerificationScreen($event)"></app-sign-document>
            <app-offer-component *ngSwitchCase="'OFFER'" [data]="currentScreenData" (onEndProcess)="showVerificationScreen($event)"></app-offer-component>
            <app-manual-validation-component *ngSwitchCase="'MANUAL'" [data]="currentScreenData" (onEndProcess)="showVerificationScreen($event)"></app-manual-validation-component>
            <app-external-component *ngSwitchDefault [data]="currentScreenData" (onEndProcess)="showVerificationScreen($event)"></app-external-component>
          </ng-container>
        </ng-template>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="stepProcess === 'RFC'">
  <form [formGroup]="entity">
  <div class="flex flex-column container-form">
    <div class="col-12 text-center">
      <img class="logo"  src="/assets/media/images/logo/main.png" alt="">
    </div>
    <div class="col-12">
      <div class="field field-flex">
        <label for="firstName">Nombre*</label>
        <input type="text" pInputText id="firstName" formControlName="firstName" pattern="^[a-zA-ZñÑ ]*$" placeholder="Juan" required />
        <ng-container *ngIf="entity.get('firstName')?.invalid && (entity.get('firstName')?.dirty || entity.get('firstName')?.touched)">
          <small class="p-error" *ngIf="entity.get('firstName')?.errors?.['required']">El nombre es obligatorio.</small>
          <small class="p-error" *ngIf="entity.get('firstName')?.errors?.['minlength']">El nombre debe tener al menos {{entity.get('firstName')?.errors?.['minlength']['requiredLength']}} caracteres.</small>
          <small class="p-error" *ngIf="entity.get('firstName')?.errors?.['pattern']">Solo se permiten letras y espacios.</small>
        </ng-container>
      </div>
    </div>
    <div class="col-12">
      <div class="field field-flex">
        <label for="secondName">Segundo Nombre</label>
        <input type="text" pInputText id="secondName" formControlName="secondName" pattern="^[a-zA-ZñÑ ]*$" placeholder="Martín"/>
        <ng-container *ngIf="entity.get('secondName')?.invalid && (entity.get('secondName')?.dirty || entity.get('secondName')?.touched)">
          <small class="p-error" *ngIf="entity.get('secondName')?.errors?.['pattern']">Solo se permiten letras y espacios.</small>
        </ng-container>
      </div>
    </div>
    <div class="col-12">
      <div class="field field-flex">
        <label for="fatherLastName">Apellido Paterno*</label>
        <input type="text" pInputText id="fatherLastName" formControlName="fatherLastName" pattern="^[a-zA-ZñÑ ]*$" placeholder="Gonzalez" required />
        <ng-container *ngIf="entity.get('fatherLastName')?.invalid && (entity.get('fatherLastName')?.dirty || entity.get('fatherLastName')?.touched)">
          <small class="p-error" *ngIf="entity.get('fatherLastName')?.errors?.['required']">El apellido paterno es obligatorio.</small>
          <small class="p-error" *ngIf="entity.get('fatherLastName')?.errors?.['minlength']">El apellido paterno debe tener al menos {{entity.get('fatherLastName')?.errors?.['minlength']['requiredLength']}} caracteres.</small>
          <small class="p-error" *ngIf="entity.get('fatherLastName')?.errors?.['pattern']">Solo se permiten letras y espacios.</small>
        </ng-container>
      </div>
    </div>
    <div class="col-12">
      <div class="field field-flex">
        <label for="motherLastName">Apellido Materno*</label>
        <input type="text" pInputText id="motherLastName" formControlName="motherLastName" pattern="^[a-zA-ZñÑ ]*$" placeholder="Rodríguez" required />
        <ng-container *ngIf="entity.get('motherLastName')?.invalid && (entity.get('motherLastName')?.dirty || entity.get('motherLastName')?.touched)">
          <small class="p-error" *ngIf="entity.get('motherLastName')?.errors?.['required']">El apellido materno es obligatorio.</small>
          <small class="p-error" *ngIf="entity.get('motherLastName')?.errors?.['minlength']">El apellido materno debe tener al menos {{entity.get('motherLastName')?.errors?.['minlength']['requiredLength']}} caracteres.</small>
          <small class="p-error" *ngIf="entity.get('motherLastName')?.errors?.['pattern']">Solo se permiten letras y espacios.</small>
        </ng-container>
      </div>
    </div>
    <div class="col-12">
      <div class="field field-flex">
        <label for="antiquity">Fecha de ingreso*</label>
        <p-calendar
          id="antiquity"
          formControlName="antiquity"
          [showIcon]="true"
          dateFormat="dd/mm/yy"
          placeholder="Selecciona una fecha"
          inputId="antiquity"
        ></p-calendar>
        <ng-container *ngIf="entity.get('antiquity')?.invalid && (entity.get('antiquity')?.dirty || entity.get('antiquity')?.touched)">
          <small class="p-error" *ngIf="entity.get('antiquity')?.errors?.['required']">La fecha de ingreso es obligatoria.</small>
        </ng-container>
      </div>
    </div>
    <div class="col-12">
      <div class="field field-flex">
        <label for="position">Posición*</label>
        <input type="text" pInputText id="position" formControlName="position" placeholder="GERENTE" required />
        <ng-container *ngIf="entity.get('position')?.invalid && (entity.get('position')?.dirty || entity.get('position')?.touched)">
          <small class="p-error" *ngIf="entity.get('position')?.errors?.['required']">La posición es obligatoria.</small>
          <small class="p-error" *ngIf="entity.get('position')?.errors?.['minlength']">La posición debe tener al menos {{entity.get('antiquity')?.errors?.['minlength']['requiredLength']}} caracteres.</small>
        </ng-container>
      </div>
    </div>
    <div class="col-12">
      <div class="field field-flex">
        <label for="canvassingId">Id de cambaceador*</label>
        <p-dropdown
          [options]="canvassingOptions"
          optionLabel="name"
          optionValue="id"
          formControlName="canvassingId"
          placeholder="Selecciona un cambaceador"
          [filter]="true"
          [showClear]="true"
          inputId="canvassingId"
        ></p-dropdown>

        <ng-container *ngIf="entity.get('canvassingId')?.invalid && (entity.get('canvassingId')?.dirty || entity.get('canvassingId')?.touched)">
          <small class="p-error" *ngIf="entity.get('canvassingId')?.errors?.['required']">El Id de cambaceador es obligatorio.</small>
        </ng-container>
      </div>
    </div>
    <div class="col-12">
      <div class="field field-flex">
        <label for="rfc">RFC*</label>
        <input type="text" pInputText id="rfc" formControlName="rfc" placeholder="XXXX900909XX1" required />
        <ng-container *ngIf="entity.get('rfc')?.invalid && (entity.get('rfc')?.dirty || entity.get('rfc')?.touched)">
          <small class="p-error" *ngIf="entity.get('rfc')?.errors?.['required']">El RFC es obligatorio.</small>
          <small class="p-error" *ngIf="entity.get('rfc')?.errors?.['minlength']">El RFC debe tener al menos {{entity.get('rfc')?.errors?.['minlength']['requiredLength']}} caracteres.</small>
          <small class="p-error" *ngIf="entity.get('rfc')?.errors?.['pattern']">El RFC no cumple con el formato de un RFC.</small>
        </ng-container>
      </div>
    </div>
    <div class="col-12">
      <div class="field field-flex">
        <label for="emailAddress">Email*</label>
        <input type="text" pInputText id="emailAddress" formControlName="emailAddress" placeholder="correo@pulpi.mx" required />
        <ng-container *ngIf="entity.get('emailAddress')?.invalid && (entity.get('emailAddress')?.dirty || entity.get('emailAddress')?.touched)">
          <small class="p-error" *ngIf="entity.get('emailAddress')?.errors?.['required']">El email es obligatorio.</small>
          <small class="p-error" *ngIf="entity.get('emailAddress')?.errors?.['minlength']">El email debe tener al menos {{entity.get('emailAddress')?.errors?.['minlength']['requiredLength']}} caracteres.</small>
          <small class="p-error" *ngIf="entity.get('emailAddress')?.errors?.['pattern']">El email no cumple con el formato válido de un email.</small>
        </ng-container>
      </div>
    </div>
    <div class="col-12">
      <div class="field field-flex mb-3">
        <label for="phoneNumber">Teléfono*</label>
        <p-inputMask mask="9999999999" id="phoneNumber" formControlName="phoneNumber" placeholder="55 3424 3312" class="p-inputMask"></p-inputMask>
        <ng-container *ngIf="entity.get('phoneNumber')?.invalid && (entity.get('phoneNumber')?.dirty || entity.get('phoneNumber')?.touched)">
          <small class="p-error" *ngIf="entity.get('phoneNumber')?.errors?.['required']">El campo es obligatorio.</small>
          <small class="p-error" *ngIf="entity.get('phoneNumber')?.errors?.['pattern']">El teléfono no cumple con el formato 55 4323 4233.</small>
        </ng-container>
      </div>
    </div>
    <ng-container *ngIf="codeSent">
      <div class="col-12">
        <div class="field field-flex">
          <label for="code">Código*</label>
          <input type="text" pInputText id="code" formControlName="code" placeholder="12ABC2" size="6" required />
          <ng-container *ngIf="entity.get('code')?.invalid && (entity.get('code')?.dirty || entity.get('code')?.touched)">
            <small class="p-error" *ngIf="entity.get('code')?.errors?.['required']">El código es obligatorio.</small>
            <small class="p-error" *ngIf="entity.get('code')?.errors?.['minlength']">El código debe tener al menos {{entity.get('code')?.errors?.['minlength']['requiredLength']}} caracteres.</small>
            <small class="p-error" *ngIf="entity.get('code')?.errors?.['pattern']">El código no cumple con el formato.</small>
          </ng-container>
        </div>
      </div>
    </ng-container>
    <div class="col-12 button-block-container my-5">
      <ng-container *ngIf="!codeSent; else elseCodeSent">
        <button pButton pRipple label="Validar teléfono" class="p-button text-center justify-content-center button-block" [disabled]="entity.invalid" (click)="sendSMS()"></button>
      </ng-container>
      <ng-template #elseCodeSent>
        <ng-container *ngIf="codeSent">
            <button *ngIf="!isPhoneVerified" pButton pRipple label="Verificar código" class="p-button text-center justify-content-center button-block" [disabled]="entity.get('code')?.invalid" (click)="continue()"></button>
            <button *ngIf="isPhoneVerified" pButton pRipple label="Continuar proceso" class="continue p-button button-primary text-center justify-content-center button-block" (click)="continueProcess()"></button>
            <button *ngIf="isPhoneVerified" pButton pRipple label="Iniciar nuevo proceso" class="p-button text-center justify-content-center button-block p-button-secondary buttonStart" (click)="startNewProcess()"></button>
        </ng-container>
          <ng-container *ngIf="timer > 0 && !isPhoneVerified; else elseTimer">
            <p class="sendCode">{{getFormattedTimer() }} para poder generar un nuevo código</p>
          </ng-container>
          <ng-template #elseTimer>
            <p *ngIf="!isPhoneVerified" class="sendCode" (click)="sendSMS()"> Reenviar código</p>
          </ng-template>
        <ng-template #elseVerificationList>
          <ng-container [ngSwitch]="currentScreenType">
            <app-form-component *ngSwitchCase="'FORM'" [data]="currentScreenData" (onEndProcess)="showVerificationScreen($event)"></app-form-component>
            <app-account-validation-component *ngSwitchCase="'DRUO'" [data]="currentScreenData" (onEndProcess)="showVerificationScreen($event)"></app-account-validation-component>
            <app-document-component *ngSwitchCase="'DOCUMENT'" [data]="currentScreenData" (onEndProcess)="showVerificationScreen($event)"></app-document-component>
            <app-ine-validation *ngSwitchCase="'INCODE'" [data]="currentScreenData" (onEndProcess)="showVerificationScreen($event)" (onUpdateStage)="retryFlow()"></app-ine-validation>
            <app-sign-document *ngSwitchCase="'WEETRUST'" [data]="currentScreenData" (onEndProcess)="showVerificationScreen($event)"></app-sign-document>
            <app-offer-component *ngSwitchCase="'OFFER'" [data]="currentScreenData" (onEndProcess)="showVerificationScreen($event)"></app-offer-component>
            <app-manual-validation-component *ngSwitchCase="'MANUAL'" [data]="currentScreenData" (onEndProcess)="showVerificationScreen($event)"></app-manual-validation-component>
            <app-external-component *ngSwitchDefault [data]="currentScreenData" (onEndProcess)="showVerificationScreen($event)"></app-external-component>
          </ng-container>
        </ng-template>
      </ng-template>
      </div>
    </div>
  </form>
</ng-container>

<ng-container *ngIf="stepProcess === 'INIT'">
  <div class="container-welcome">
    <img src="/assets/media/images/logo/main.png" alt="">
    <h2 class="text-center">Bienvenido a la liga <br>express</h2>
    <small>
      La liga express para solicitar un crédito es una herramienta confiable y ágil diseñada para facilitar el acceso a tus necesidades financieras. Gracias a su interfaz intuitiva, puedes completar el proceso de manera rápida y segura, brindando tranquilidad al usuario mientras optimiza su tiempo con un servicio eficiente y accesible.
    </small>
    <div class="grid">
      <div class="col-12 button-block-container my-5">

        <button pButton pRipple label="Continuar" class="p-button text-center justify-content-center button-block" (click)="continue()"></button>
      </div>
    </div>

  </div>
</ng-container>
<p-toast></p-toast>

